window.addEventListener('load', function () {

	// Header glass
	var scroll = $(window).scrollTop();
	if (scroll >= 50) {
		$("body").addClass("scrolled");
		$(".header").addClass("tint");
	} else {
		$("body").removeClass("scrolled");
		$(".header").removeClass("tint");
	}

	$(window).scroll(function () {
		var scroll = $(window).scrollTop();
		if (scroll >= 50) {
			$("body").addClass("scrolled");
			$(".header").addClass("tint");
		} else {
			$("body").removeClass("scrolled");
			$(".header").removeClass("tint");
		}
	});

	$('.work-slider-more').owlCarousel({
		loop: false,
		autoplay: false,
		margin: 30,
		center: true,
		nav: true,
		dots: false,
		navContainer: '#custom-nav2',
		onInitialized: counter2,
		onTranslated: counter2,
		responsive: {
			0: {
				items: 1,
				stagePadding: 40,
			},
			576: {
				items: 1,
				stagePadding: 100,
			},
			992: {
				items: 2,
				stagePadding: 140,
			},
			1800: {
				items: 3,
				stagePadding: 200,
			}
		}
	});

	$('.work-slider').owlCarousel({
		loop: false,
		autoplay: false,
		margin: 30,
		center: true,
		nav: true,
		dots: false,
		navContainer: '#custom-nav',
		onInitialized: counter,
		onTranslated: counter,
		responsive: {
			0: {
				items: 1,
				stagePadding: 40,
			},
			576: {
				items: 1,
				stagePadding: 100,
			},
			992: {
				items: 2,
				stagePadding: 140,
			},
			1800: {
				items: 3,
				stagePadding: 200,
			}
		}
	});
	function counter(event) {
		var element = event.target;
		var items = event.item.count;
		var item = event.item.index + 1;
		if (item > items) {
			item = item - items
		}
		$('#custom-count').html(item + " - " + items);
	}
	function counter2(event) {
		var element = event.target;
		var items = event.item.count;
		var item = event.item.index + 1;
		if (item > items) {
			item = item - items
		}
		$('#custom-count2').html(item + " - " + items);
	}

	$('.news-slider').owlCarousel({
		loop: false,
		autoplay: false,
		margin: 30,
		center: false,
		nav: false,
		dots: false,
		responsive: {
			0: {
				items: 1,
				stagePadding: 40,
			},
			576: {
				items: 2,
				stagePadding: 40,
			},
			768: {
				items: 3,
				stagePadding: 0,
			}
		}
	});

	$('.iprex-slider').owlCarousel({
		loop: true,
		autoplay: true,
		animateOut: 'fadeOut',
		mouseDrag: false,
		touchDrag: false,
		margin: 0,
		center: false,
		nav: false,
		dots: false,
		responsive: {
			0: {
				items: 1,
				stagePadding: 0,
			},
			576: {
				items: 1,
				stagePadding: 0,
			},
			768: {
				items: 1,
				stagePadding: 0,
			}
		}
	});

	$('.quote-slider').owlCarousel({
		loop: true,
		autoplay: true,
		animateOut: 'fadeOut',
		mouseDrag: false,
		touchDrag: false,
		margin: 0,
		center: false,
		nav: false,
		dots: false,
		responsive: {
			0: {
				items: 1,
				stagePadding: 0,
			},
			576: {
				items: 1,
				stagePadding: 0,
			},
			768: {
				items: 1,
				stagePadding: 0,
			}
		}
	});

	/* Lenis page scroll
	const lenis = new Lenis()

	function raf(time) {
		lenis.raf(time)
		requestAnimationFrame(raf)
	}
	requestAnimationFrame(raf);

	lenis.on('scroll', ScrollTrigger.update);

	gsap.ticker.add((time) => {
		lenis.raf(time * 1000)
	})

	gsap.ticker.lagSmoothing(0);

	*/

	// Work hover
	$(".client-hover").on("mouseenter", function () {
		var $bgurl = $(this).data("bgurl");
		console.log($bgurl);
		$('.client-img .bg-img').css('background-image', 'url(' + $bgurl + ')');
	}).on("mouseleave", function () {
		//
	});

	$('.read-more-toggle').on('click', function (e) {
		e.preventDefault();
		$(this).toggleClass('active');
		$('.read-more-reveal').slideToggle();
		$('.fade-mask').toggleClass('hidden');
	});

});

document.addEventListener('wpcf7mailsent', function (event) {
	// Replace 123 with your form ID
	if (event.detail.contactFormId == '3471') {
		window.location.href = 'https://thisismc2.com/wp-content/uploads/2024/09/High-Growth-50-Report.pdf';
	}
}, false);
